function initFancybox(){
    // OP kein plan was das hier bringt ist aus der alten sT3r
    jQuery("a[class*=lightbox]").each(function(index, link) {
        if(link.href.split('#')[0] === (window.location.origin + window.location.pathname)) {
            link.href = "#" + link.href.split('#')[1];
        }
    });
    //Fancybox init für die ganze Webseite
    $('[data-fancybox="*"]').fancybox({
        // Options will go here
    });
}